import { createRadarWorldTransform } from "../radar-transform.js";
/**
 * Build 24537688 liefert Overview und 435649 Weltkollisionsdreiecke. Bis das
 * kompakte Runtime-Mesh, Materialantworten und Portale validiert sind, darf die
 * Registry daraus trotzdem noch kein aktives Physikasset liefern.
 */
export const dust2PhysicsManifest = {
    manifestVersion: 1,
    status: "setup_required",
    mapId: "dust2",
    mapRevision: "Video Playbook · 02.08.2026",
    radar: {
        path: "assets/maps/de_dust2_radar.png",
        sha256: "0828297130ce26db25a299806ff743df9104de634a3e64b52b358f6f4399354d",
        widthPixels: 1024,
        heightPixels: 1024,
    },
    radarTransform: createRadarWorldTransform({
        posXHu: -2476,
        posYHu: 3239,
        scaleHuPerPixel: 4.4,
        widthPixels: 1024,
        heightPixels: 1024,
    }),
    layers: [{ id: "main", label: "Main", minZHu: -320, maxZHu: 1174 }],
    source: {
        manifestPath: "assets/physics/manifests/dust2.json",
        cs2BuildId: "24537688",
        triangleCount: 435649,
    },
    missing: ["openings", "portals", "materials"],
};
